import Head from 'next/head';
import 'antd/dist/antd.css';
import 'civitfun-ocr-ui-component/style.css';
import '../styles/globals.css';
import { BookingContextProvider } from '../shared/contexts/Booking.context';
import { LanguageContextProvider } from '../shared/contexts/Language.context';
import { ErrorContextProvider } from '../shared/contexts/Error.context';
import { ThemeContextProvider } from '../shared/contexts/Theme.context';
import { LoginContextProvider } from '../shared/contexts/Login.context';
import { useState, useEffect } from 'react';
import * as GtmUtils from '../shared/utils/GtmUtils';
import apiConfig from '../shared/config/api.config';
import 'react-phone-input-2/lib/plain.css';
import { createMetricsCookie } from '../shared/utils/cookies';

function MyApp({ Component, pageProps }) {
  const [gAnalyzed, setGAnalyzed] = useState(false);
  const [title, setTitle] = useState('Check-in');
  const [cookiesEnabled, setCookiesEnabled] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV == 'production') {
      if (!gAnalyzed) {
        GtmUtils.initialize();
        setGAnalyzed(true);
      }
    }
    setTitle(window.location.hostname?.includes('checkout') ? 'Check-out' : 'Check-in');
    const processType = window.location.href.includes('checkout') ? 'checkout' : 'checkin';

    try {
      localStorage.setItem('process-type', processType);
      setCookiesEnabled(true);
      createMetricsCookie();
    } catch (error) {
      console.error(error);
      setCookiesEnabled(false);
    }

    apiConfig.setUpInterceptors();
  }, []);

  if (cookiesEnabled === null) {
    return <></>;
  } else if (!cookiesEnabled) {
    return (
      <h1>You must enable cookies in your browser to be able to access the online check-in</h1>
    );
  } else
    return (
      <>
        <div id="dom-events-subscriber" />

        <Head>
          <title>{title}</title>
          <meta name="robots" content="noindex"></meta>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"
          ></meta>
          <script src="https://unpkg.com/aliceonboarding@8.1.1/dist/aliceonboarding.min.js"></script>
          <link
            rel="stylesheet"
            href="https://unpkg.com/aliceonboarding@8.1.1/dist/aliceonboarding.css"
          />
        </Head>

        <LanguageContextProvider>
          <ThemeContextProvider>
            <LoginContextProvider>
              <ErrorContextProvider>
                <BookingContextProvider>
                  <Component {...pageProps} />
                </BookingContextProvider>
              </ErrorContextProvider>
            </LoginContextProvider>
          </ThemeContextProvider>
        </LanguageContextProvider>
      </>
    );
}

export default MyApp;
